import { IAnimal } from 'src/dto/animal.dto'

export const getAnimalAge = (date?: string | null) => {
  if (!date) return '-'

  const birthDate = new Date(date)
  const today = new Date()

  let years = today.getFullYear() - birthDate.getFullYear()
  let months = today.getMonth() - birthDate.getMonth()

  if (today.getDate() < birthDate.getDate()) {
    months -= 1
  }

  if (months < 0) {
    years -= 1
    months += 12
  }

  return `${months > 0 ? `${Math.max(years, 0)} anos e ${Math.max(months, 0)} meses` : `${Math.max(years, 0)} anos`}  `
}

export const calculateGestationTime = (diagnosisDate?: string, reproductionDate?: string): number | null => {
  if (!diagnosisDate || !reproductionDate) return null

  const diagDate = new Date(diagnosisDate)
  const repDate = new Date(reproductionDate)

  const diffInMillis = diagDate.getTime() - repDate.getTime()
  const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24))

  return diffInDays >= 0 ? diffInDays : null
}

export const calculateBirthForecast = (diagnosisDate?: string, reproductionDate?: string): Date | null => {
  const gestationTime = calculateGestationTime(diagnosisDate, reproductionDate)

  if (diagnosisDate && gestationTime !== null) {
    const diagDate = new Date(diagnosisDate)
    const daysToAdd = 280 - gestationTime

    diagDate.setDate(diagDate.getDate() + daysToAdd)

    return diagDate
  } else if (reproductionDate) {
    const repDate = new Date(reproductionDate)
    return repDate
  }

  return null
}

export const isTodayOutsideForecast = (diagnosisDate?: string, reproductionDate?: string): boolean => {
  const forecast = calculateBirthForecast(diagnosisDate, reproductionDate)

  if (!forecast) return false

  const today = new Date()

  const forecastDate = new Date(forecast.getFullYear(), forecast.getMonth(), forecast.getDate())
  const todayNormalized = new Date(today.getFullYear(), today.getMonth(), today.getDate())

  const isPremature = todayNormalized.getTime() < forecastDate.getTime()
  return isPremature
}

export const filterAnimalsByReproductionAge = (animals: IAnimal[]) => {
  const today = new Date()

  return animals.filter((a) => {
    if (!a.sexo || a.sexo !== 'F') return false
    if (!a.dataNascimento) return false

    const bornDate = a.dataNascimento
    const bornPlus12Months = new Date(bornDate)

    bornPlus12Months.setMonth(bornPlus12Months.getMonth() + 12)

    return today >= bornPlus12Months
  })
}
